import React, { useRef, useState } from "react";
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import { useQuery } from "@tanstack/react-query";
import { getAthletes } from "data/Querys";
import Loader from "components/general/Loader";
import NotAvailable from "components/common/NotAvailable";
import AthletesTable from "components/common/participants/AthletesTable";
import SelectorDiscipline from "components/common/selectors/selector-discipline/selectorDiscipline";
import { Stack } from "react-bootstrap";
import SelectorNoc from "components/common/selectors/selector-noc";
import { useLabels } from 'components/general/Label';
import { ALL_URL, SELECTOR_DISPLAY_TYPE } from "helpers/utils";
import { ResetFilterButton } from "components/common/ResetFilterButton";


const AthletesByNoc = () => {
    const [dataState, setDataState] = React.useState([]);
    const inputRef = useRef(null);
    const [competitorFilter, setcompetitorFilter] = useState();
    const fLabel = useLabels()
    const placeholder = fLabel({ data: 'LabelCompetitor' });
    const {
        mirs_competition,
        mirs_language,
        mirs_discipline,
        mirs_noc
    } = useUrlFriendlyToParameters()
    const { data, isError, isLoading } = useQuery(
        {
            queryKey: ['athletes', mirs_competition, mirs_language, 'A'],
            queryFn: getAthletes,
            refetchInterval: 0,
        });


    React.useEffect(() => {
        // let athletes = data?.persons?.filter(row => row.mainFunction?.functionCategory === 'A') // Only shows the Athletes
        let filterData = data?.persons; //athletes

        if (mirs_discipline && mirs_discipline !== ALL_URL.ALL_DISC) {
            filterData = data?.persons?.filter(item => item?.disciplines?.some(itemDiscipline => itemDiscipline?.code === mirs_discipline))
            if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC)
                filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        }
        if (mirs_noc && mirs_noc !== ALL_URL.ALL_NOC) {
            filterData = filterData?.filter(item => item?.organisation?.code === mirs_noc);
        }
        if (competitorFilter) {
            filterData = filterData?.filter(item => item?.name?.toLowerCase().includes(competitorFilter?.toLowerCase()));
        };
        setDataState(filterData);
    }, [data, mirs_noc, mirs_discipline, competitorFilter]);


    if (isError) {
        return <NotAvailable label="LabelNoDataAvailable" />;
    }
    if (isLoading) {
        return <Loader />;
    }
    if (!data?.persons) {
        return <NotAvailable label="LabelNoDataAvailable" />
    }

    const handleOnChange = event => {
        const { name, value } = event.target;
        setcompetitorFilter(value);
    };

    const clearFilterText = () => {
        if (inputRef?.current?.value) {
            inputRef.current.value = "";
        }
        setcompetitorFilter("");
    };

    const onClearFilters = () => {
        clearFilterText();
    }

    return (
        <div className='mirs-page-container'>
            <Stack direction="horizontal" className='selectors-container'>
                <SelectorDiscipline display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="athletesbynoc" />
                <SelectorNoc display_type={SELECTOR_DISPLAY_TYPE.COMBO} page="athletesbynoc" />
                <div className="d-flex competitor-search">
                    {/*<label htmlFor="city"><Label data={"HeaderNOC"} /></label>*/}
                    <input type="text" ref={inputRef} className="form-control" name="Competitor" id="Competitor"
                        placeholder={placeholder}
                        onChange={handleOnChange} />
                </div>
                <ResetFilterButton clearFilterText={clearFilterText} filterText={competitorFilter} page='athletesbynoc' onClearFilters={onClearFilters} />
            </Stack>
            <div>
                {dataState && <AthletesTable data={dataState} key={`athletes`} />}
            </div>
        </div>
    )
};

export default AthletesByNoc

